import React from 'react';
import { motion } from 'framer-motion';
import { Ruler, Clock, TrendingUp, Users } from 'lucide-react';
const features = [{
  num: 1,
  title: '+600 Planos Con Medidas Exactas, Listos Para Fabricar',
  description: <>
        Estanterías, racks, mesas, escritorios, equipamiento de gym y mucho más.
        Cada plano incluye{' '}
        <span className="text-white font-bold" data-id="element-78">
          instrucciones paso a paso, esquemas detallados y lista de materiales
          precisa.
        </span>{' '}
        No hay lugar para adivinanzas.
      </>,
  sub: 'Es como tener un MAESTRO HERRERO al lado tuyo guiándote en cada proyecto.',
  icon: Ruler,
  image: '📐'
}, {
  num: 2,
  title: 'Sistema de Construcción Rápida — Piezas Terminadas en 24 Horas',
  description: <>
        Cada plano sigue una secuencia lógica:{' '}
        <span className="text-white font-bold bg-[#333] px-1 rounded" data-id="element-79">
          medir → cortar → soldar → acabar.
        </span>{' '}
        Sin semanas de prueba y error. Sin proyectos abandonados juntando polvo.
        Seguís la ruta y la pieza se arma prácticamente sola.
      </>,
  sub: 'Más tiempo FABRICANDO y VENDIENDO. Menos tiempo rascándote la cabeza.',
  icon: Clock,
  image: '⚡'
}, {
  num: 3,
  title: 'Catálogo de Alta Demanda + Optimización de Materiales',
  description: <>
        Cada diseño fue seleccionado porque es de los{' '}
        <span className="text-white font-bold" data-id="element-80">
          más buscados y vendidos del mercado.
        </span>{' '}
        Y cada plano está pensado para aprovechar al máximo cada barra de hierro
        — comprás cantidades exactas, dejás de tirar dinero en material
        sobrante.
      </>,
  sub: 'Fabricás lo que los clientes piden. Gastás solo lo necesario. Ganás más.',
  icon: TrendingUp,
  image: '📈'
}, {
  num: 4,
  title: 'Apto Para Principiantes Absolutos y Profesionales',
  description: <>
        <span className="text-white font-bold underline decoration-[#FF6B00]" data-id="element-81">
          NO necesitás ser maestro herrero
        </span>{' '}
        ni tener maquinaria costosa. Desde piezas simples hasta muebles grandes
        y ambiciosos, hay proyectos para TODOS los niveles. Empezá donde estés y
        crecé a tu ritmo.
      </>,
  sub: '¡Hay algo para todos — y con este nivel de detalle, te vas a sorprender de lo rápido que avanzás!',
  icon: Users,
  image: '👷'
}];
export function FeatureGrid() {
  return <section className="py-6 px-4 bg-[#0d0d0d] relative overflow-hidden" data-id="element-82">
      <div className="max-w-6xl mx-auto" data-id="element-83">
        <div className="space-y-8" data-id="element-84">
          {features.map((feature, index) => <div key={index} className={`flex flex-col md:flex-row gap-5 items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : ''}`} data-id="element-85">
              <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="w-full md:w-5/12" data-id="element-86">
                <div className="aspect-video bg-[#1a1a1a] rounded-lg border border-[#333] relative flex items-center justify-center overflow-hidden group hover:border-[#FF6B00]/50 transition-colors duration-300 shadow-xl" data-id="element-87">
                  <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#222] to-[#111]" data-id="element-88" />
                  <div className="text-7xl relative z-10 transform group-hover:scale-110 transition-transform duration-500" data-id="element-89">
                    {feature.image}
                  </div>
                  <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-[#FF6B00]" data-id="element-90" />
                  <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-[#FF6B00]" data-id="element-91" />
                </div>
              </motion.div>

              <motion.div initial={{
            opacity: 0,
            x: index % 2 === 0 ? 30 : -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="w-full md:w-7/12" data-id="element-92">
                <div className="flex items-center gap-3 mb-2" data-id="element-93">
                  <div className="p-2 bg-[#FF6B00]/10 rounded-lg border border-[#FF6B00]/20" data-id="element-94">
                    <feature.icon className="w-6 h-6 text-[#FF6B00]" data-id="element-95" />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white uppercase tracking-wide" data-id="element-96">
                    Característica #{feature.num}
                  </h3>
                </div>
                <h4 className="text-2xl md:text-3xl font-bold text-white mb-2 leading-tight" data-id="element-97">
                  {feature.title}
                </h4>
                <p className="text-gray-400 leading-relaxed text-base md:text-lg mb-2" data-id="element-98">
                  {feature.description}
                </p>
                <p className="text-[#FF6B00] font-medium text-base md:text-lg italic border-l-2 border-[#FF6B00] pl-4" data-id="element-99">
                  {feature.sub}
                </p>
              </motion.div>
            </div>)}
        </div>

        {/* Stats Bar */}
        <div className="mt-10 grid grid-cols-3 gap-4 md:gap-8" data-id="element-100">
          {[{
          num: '600+',
          label: 'Planos Metálicos'
        }, {
          num: '24h',
          label: 'Para Terminar Piezas'
        }, {
          num: '0',
          label: 'Desperdicio de Material'
        }].map((stat, i) => <div key={i} className="text-center p-4 bg-[#1a1a1a] rounded-lg border border-[#333] hover:border-[#FF6B00]/30 transition-colors shadow-lg" data-id="element-101">
              <div className="text-4xl md:text-5xl font-bold text-[#FF6B00] mb-2" style={{
            fontSize: '28px'
          }} data-id="element-102">
                {stat.num}
              </div>
              <div className="text-sm md:text-base text-gray-300 font-medium uppercase tracking-wide" style={{
            fontSize: '12px'
          }} data-id="element-103">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}